import React from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import useLoading from '../../../../hooks/useLoading';


import useAppRouter from "../../../../hooks/useAppRouter";
import {logError} from "../../../../libs/utils/logError";
import {config} from "../../../../libs/config/config";



interface OpenRoomConfirmModalParams {
  roomId: number | undefined;
  onSubmitted: () => Promise<void>;
}

export const OpenRoomConfirmModal = (props: OpenRoomConfirmModalParams) => {
  const { roomId, onSubmitted } = props;

  const withLoading = useLoading();
  const location = useLocation();
  const { goto } = useAppRouter();


  const handleOpenRoom = async () => {
    withLoading(async () => {
      if (config.room.page.release.url === undefined) {
        await logError(
          location.pathname,
          'ROOMのURLが設定されていません。',
        );
        goto('internalServerError');
        return;
      }

      let { url } = config.room.page.release;
      if (roomId) {
        url = `${url}?roomId=${roomId}`;
      }

      window.open(url, '_blank', 'noopener,noreferrer');

      onSubmitted();
    });
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted()}
        className="w-1/3"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
        style={{
          content: {
            position: 'fixed',
            top: '1rem'
          }
        }}
      >
        <section className="modal-background">
          <div className="form-modal-container">
            <div className="form-modal-title">
              <h1 className="font-semibold">確認</h1>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => onSubmitted()}
              >
                ×
              </button>
            </div>
            <div className="form-modal-content">
              <div className="text-primary text-sm font-semibold grid grid-cols-1 w-full break-all">
                <p>
                  ブラウザの新規タブでROOMを起動します。<br />
                  既に別タブでROOMを開いている場合は閉じてください。
                </p>
              </div>
            
            </div>
            <div className="form-modal-footer-container">
              <div className="form-modal-footer">
                <button
                  className="btn-sub"
                  type="button"
                  onClick={() => onSubmitted()}
                >
                  キャンセル
                </button>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => handleOpenRoom()}
                >
                  OK
                </button>
                
              </div>
            </div>
          </div>
        </section>
      </ReactModal>
    </>
  );
}
